"use client";
import { jsx as e } from "react/jsx-runtime";
import { createContext as t, useCallback as n, useMemo as r, useRef as i } from "react";
//#region src/components/popover/PopoverGroup.tsx
var a = t(null);
function o({ children: t }) {
	let o = i(null), s = n((e, t) => {
		o.current?.id !== e && o.current?.close(), o.current = {
			id: e,
			close: t
		};
	}, []), c = n((e) => {
		o.current?.id === e && (o.current = null);
	}, []), l = r(() => ({
		activate: s,
		release: c
	}), [s, c]);
	return /* @__PURE__ */ e(a.Provider, {
		value: l,
		children: t
	});
}
//#endregion
export { o as PopoverGroup, a as PopoverScopeContext };
